import React from "react";
import SkeletonBox from "./skeleton";

const BannerpageSkeleton = () => {

    return (
        <div className="mx-auto h-auto w-full self-start px-6 md:w-[1280px]">
            <div className="w-full pb-4 pt-6 md:pb-10 md:pt-10">
                <SkeletonBox classname="w-full h-[54.41px] rounded-lg" />
            </div>
        </div>
    );
};

export default BannerpageSkeleton;
